exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  text-align: center; }\n\nul {\n  list-style: none;\n  padding: 0; }\n\nul li {\n    margin: 1em;\n    width: calc(50% - 1em);\n    display: inline-block;\n    vertical-align: top;\n    -webkit-box-shadow: 2px 2px 3px #333;\n            box-shadow: 2px 2px 3px #333;\n    padding: 20px;\n    border: 1px solid #ad0e68; }\n\nul li:nth-child(2n + 1) {\n      margin-left: 0; }\n\nul li:nth-child(2n) {\n      margin-right: 0; }\n\nul li img {\n      width: calc( 100% + 40px);\n      margin-left: -20px;\n      margin-right: -20px; }\n\nul li .title {\n      margin-left: -20px;\n      margin-right: -20px;\n      margin-top: -20px;\n      color: white;\n      padding: 0.2em 20px;\n      background-color: #ad0e68;\n      line-height: 1.5em;\n      font-size: 1.1em; }\n\nul li .title a {\n        color: white; }\n\nul li .title .date {\n        font-size: 0.6em; }\n\nul li .content {\n      margin: 1em 0; }\n\nul li p {\n      margin: 0; }\n\nul li .more {\n      text-align: right; }\n\nh1 {\n  margin: 1em 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/blog/blog.component.scss
// module id = ../../../../../src/app/blog/blog.component.scss
// module chunks = main